var loadNews;

$(function(){

  loadNews = {
    page : 1,
    loading : false,
    finished : false,
    typeView: "grid",
    textSearch: textSearch,

    formataURL : function(url){
      url = url.replace("http://","").replace("https://","");
      let pos = url.indexOf("/");
      url = url.substr(0,pos);
      return url;
    },

    formataData : function(dataBD){
      dataBD = new Date(dataBD);
      let vDia = dataBD.getDate();
      if(vDia.toString().length==1) vDia = "0"+vDia;
      let vMes = dataBD.getMonth();
      if(vMes.toString().length==1) vMes = "0"+vMes;
      let vAno = dataBD.getFullYear();
      return vDia + "/" + vMes + "/" + vAno;
    },

    formataResumo: function(resumo){
      return resumo.replace(/(<([^>]+)>)/gi, "").substr(0,300);
    },

    formataImg : function(img, logo){
      return (img!="") ? `<img src="/api/v1/diminuator?file=img/news/${img}&w=350&h=180" class="image-news" />` : `<div class="logo-news"><img src="${logo}" class="logo" /></div>`;
    },

    analytics: function(){
      let loadingElements = document.getElementsByClassName('loading');
      if (typeof gtag === "function" && loadingElements.length > 0) {
          gtag('event', 'page_view', {
              'event_category': 'news',
              'event_label': 'Page ' + loadNews.page,
              'value': 1
          });
      }
    },

    showType: function(type){
      loadNews.typeView = type;
      if(loadNews.typeView=="list"){
        $(".lista-noticias").removeClass("grid").addClass("list");
        $(".view-type.list").removeClass("disabled").addClass("enabled");
        $(".view-type.grid").removeClass("enabled").addClass("disabled");
        $(".lista-noticias .noticia").removeClass("cell large-4").addClass("cell large-12");
      } else {
        $(".lista-noticias").removeClass("list").addClass("grid");
        $(".view-type.grid").removeClass("disabled").addClass("enabled");
        $(".view-type.list").removeClass("enabled").addClass("disabled");
        $(".lista-noticias .noticia").removeClass("cell large-12").addClass("cell large-4");
      }
    },

    load: function(){
      if(loadNews.finished) return;
      $(".loading").fadeIn();
      loadNews.loading = true;
      loadNews.page = loadNews.page + 1;
      $.ajax({
        dataType: "json",
        url: loadNews.textSearch == "" ? `/api/v1/news/${loadNews.page}/` : `/api/v1/news/${loadNews.textSearch}/${loadNews.page}/`,
        success: function(req){
          if (req[1].news.length == 0) {
            loadNews.finished = true;
          } else {
            //advertising
            let ad = req[0].advertising[0];
            let ad_template = `<div class="cell large-12 ultra-banner">
                              <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                              <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                              </div>`;
            $(".lista-noticias").append(ad_template);
            $.get(`/api/advertising-views/${ad.id}/`)
            //news
            $(req[1].news).each(function(ix, not){
              let template = `
                <div class="noticia cell large-4">
                  <div class="content grid-x grid-padding-x">
                    <div class="col-foto cell large-3">
                      <div class="foto${not.imagem==""?" image-default":""}"><a href="/redirect/news/?url=${not.url}" rel="nofollow" target="_blank">${loadNews.formataImg(not.imagem,not.logo)}</a></div>
                    </div>
                    <div class="col-info cell large-9">
                      <div class="organizacao">
                        <span><a href="/redirect/news/?url=https://${loadNews.formataURL(not.url)}" rel="nofollow" target="_blank">${loadNews.formataURL(not.url)}</a></span>
                      </div>
                      <div class="data">${loadNews.formataData(not.data)}</div>
                      <div class="clear-both"></div>
                      <div class="texto">
                        <div class="titulo"><a href="/redirect/news/?url=${not.url}" rel="nofollow" target="_blank">${not.titulo}</a></div>
                        <div class="resumo"><a href="/redirect/news/?url=${not.url}" rel="nofollow" target="_blank">${loadNews.formataResumo(not.resumo)} [...]</a></div>
                      </div>
                    </div>
                  </div>
                </div>
              `
              $(".lista-noticias").append(template);
            })
          }
          $(".loading").fadeOut();
          loadNews.analytics();
          loadNews.loading = false;
          loadNews.showType(loadNews.typeView);
        }
      });

    },

    search: function(div){
      var search = $(`.search-form.${div} #searchText`).val().toString();
      if(!search){
          document.location.href = `/noticias/`;
      } else {
          document.location.href = `/noticias/${search}/`;
      }
    }

  }



  $(".search-form.desktop .icon").click(function(){
    $(".search-form .form").animate({width:'toggle'},350);
    $("#searchText").focus();
  });

  $(".search-form.desktop #btnOk").click(function(){ loadNews.search('desktop'); });
  $(".search-form.mobile #btnOk").click(function(){ loadNews.search('mobile'); });

  $(".search-form.desktop #searchText").on('keypress',function(e) {
    if(e.which == 13) $(".search-form.desktop #btnOk").click()
  });

  $(".view-type.grid").click(function(){ loadNews.showType("grid") });
  $(".view-type.list").click(function(){ loadNews.showType("list") });

  if(textSearch){
    $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
    $(".search-form").addClass("search")
  }

  window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadNews.loading === false) {
        loadNews.load();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };

});

$("#back-to-top").click(function() {
  $("html, body").animate({ scrollTop: 0 }, "slow", function() {
    $('#back-to-top').removeClass('visible');
  });
});
